import {
    useState
} from "react";
import {
    useWindowDimensions,
    StyleSheet,
    ScrollView,
    View
} from "react-native";
import {
    BrandMark
} from "./brand";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    AvatarGroup,
    TextInput,
    Separator,
    Avatar,
    Button,
    Badge,
    Empty,
    Card,
    Chip,
    Item,
    Tabs,
    Icon,
    Text,
    Kbd
} from "ncore-ui-kit";
import {
    useDocsI18n
} from "../i18n";
import {
    MessageCircle,
    BadgeCheck,
    UserCheck,
    Bookmark,
    Calendar,
    UserPlus,
    Ellipsis,
    Repeat2,
    Share2,
    Search,
    MapPin,
    Heart,
    Link,
    Mail,
    Bell,
    Pin
} from "lucide-react-native";
import Svg, {
    Polygon,
    Circle,
    Rect
} from "react-native-svg";
import {
    createKitIcon
} from "../components/kitIcons";

const SearchIcon = createKitIcon(Search);

const BellIcon = createKitIcon(Bell);

const EllipsisIcon = createKitIcon(Ellipsis);

const MailIcon = createKitIcon(Mail);

const UserPlusIcon = createKitIcon(UserPlus);

const UserCheckIcon = createKitIcon(UserCheck);

const LinkIcon = createKitIcon(Link);

const HeartIcon = createKitIcon(Heart);

const MessageCircleIcon = createKitIcon(MessageCircle);

const Repeat2Icon = createKitIcon(Repeat2);

const BookmarkIcon = createKitIcon(Bookmark);

const Share2Icon = createKitIcon(Share2);

const NAV = [
    "feed",
    "discover",
    "forum",
    "events"
] as const;

const TABS = [
    {
        key: "posts",
        count: 186
    },
    {
        key: "replies",
        count: 742
    },
    {
        key: "collections",
        count: 9
    },
    {
        key: "likes"
    }
] as const;

const POSTS = [
    {
        tags: [
            "designSystems",
            "spacing",
            "token"
        ],
        art: "spacing",
        isPinned: true,
        key: "spacing",
        isLiked: true,
        comments: 36,
        reposts: 54,
        likes: 428,
        preview: [
            "can",
            "selin"
        ]
    },
    {
        tags: [
            "accessibility",
            "color"
        ],
        preview: ["defne"],
        art: "contrast",
        isPinned: false,
        key: "contrast",
        isLiked: false,
        comments: 18,
        reposts: 23,
        likes: 212
    },
    {
        isPinned: false,
        tags: [
            "focusRing",
            "keyboard",
            "web"
        ],
        isLiked: false,
        comments: 41,
        key: "focus",
        art: "none",
        preview: [
            "mert",
            "emre"
        ],
        reposts: 6,
        likes: 97
    }
] as const;

const PEOPLE = [
    "selin",
    "mert",
    "defne",
    "emre"
] as const;

const TAGS = [
    "designSystems",
    "accessibility",
    "typography",
    "motion",
    "figma",
    "token",
    "reactNative",
    "research"
] as const;

const CONTRASTS = [
    {
        ratio: 4.6,
        color: "1"
    },
    {
        ratio: 7.8,
        color: "3"
    },
    {
        color: "inverse",
        ratio: 12.1
    }
] as const;

const COVER_RATIO = 1200 / 180;

const ART_RATIO = 600 / 240;

const FOLLOWERS = 2481;

const FOLLOWING = 312;

const POST_COUNT = 186;

const SQUARES = [
    {
        color: "2",
        size: 14,
        x: 270
    },
    {
        color: "3",
        size: 28,
        x: 296
    },
    {
        color: "4",
        size: 52,
        x: 336
    },
    {
        color: "8",
        size: 82,
        x: 400
    }
] as const;

const DOT_COLUMNS = Array.from({
    length: 10
}, (_, index) => 760 + index * 22.5);

const DOT_ROWS = Array.from({
    length: 8
}, (_, index) => 25 + index * 21);

const PURPLE_BARS = [
    647,
    673,
    700
];

const stylesheet = StyleSheet.create({
    header: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        width: "100%"
    },
    spread: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    swatch: {
        justifyContent: "space-between",
        flex: 1
    },
    start: {
        alignItems: "flex-start"
    },
    baseline: {
        alignItems: "baseline",
        flexDirection: "row"
    },
    page: {
        alignItems: "center",
        minHeight: "100%",
        flexGrow: 1
    },
    wrap: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    absolute: {
        position: "absolute"
    },
    clip: {
        overflow: "hidden",
        width: "100%"
    },
    shrink: {
        flexShrink: 1,
        minWidth: 0
    },
    ratio: {
        width: "100%"
    },
    shell: {
        width: "100%"
    },
    caption: {
        left: "45%",
        top: "70%"
    },
    grow: {
        flex: 1,
        flexGrow: 1
    }
});

const Cover = () => {
    const {
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        categorical
    } = colors.chart;

    const {
        container,
        text
    } = colors.content;

    return <Svg
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 1200 180"
        height="100%"
        width="100%"
    >
        <Rect
            fill={container.inverse}
            height={180}
            width={1200}
            x={0}
            y={0}
        />
        <Circle
            fill={categorical["4"]}
            r={100}
            cx={0}
            cy={0}
        />
        <Rect
            fill={categorical["3"]}
            height={180}
            width={150}
            x={253}
            y={0}
        />
        <Circle
            fill={categorical["2"]}
            cx={160}
            cy={111}
            r={75}
        />
        <Circle
            fill={categorical["4"]}
            cx={327}
            cy={107}
            r={50}
        />
        <Circle
            fill={categorical["1"]}
            cx={508}
            cy={180}
            r={107}
        />
        {
            PURPLE_BARS.map((x) => <Rect
                fill={categorical["5"]}
                height={180}
                width={10}
                key={x}
                y={0}
                x={x}
            />)
        }
        {
            DOT_COLUMNS.map((cx) => DOT_ROWS.map((cy) => <Circle
                fill={text.contrastHigh}
                key={`${cx}-${cy}`}
                cx={cx}
                cy={cy}
                r={2.5}
            />))
        }
        <Polygon
            points="1083,5 1000,180 1171,180"
            fill={categorical["8"]}
        />
        <Polygon
            points="1083,115 1050,180 1116,180"
            fill={categorical["2"]}
        />
        <Circle
            fill={categorical["7"]}
            cx={1171}
            cy={42}
            r={40}
        />
        <Rect
            fill={categorical["3"]}
            width={1200}
            height={8}
            y={172}
            x={0}
        />
    </Svg>;
};

const SpacingArt = () => {
    const {
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        categorical
    } = colors.chart;

    const {
        container
    } = colors.content;

    return <Svg
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 600 240"
        height="100%"
        width="100%"
    >
        <Rect
            fill={container.inverse}
            height={240}
            width={600}
            x={0}
            y={0}
        />
        <Circle
            stroke={categorical["1"]}
            strokeWidth={24}
            fill="none"
            cx={150}
            cy={78}
            r={36}
        />
        <Circle
            stroke={categorical["1"]}
            strokeWidth={24}
            fill="none"
            cx={150}
            cy={158}
            r={46}
        />
        {
            SQUARES.map(({
                color,
                size,
                x
            }) => <Rect
                fill={categorical[color]}
                y={150 - size}
                height={size}
                width={size}
                key={x}
                x={x}
            />)
        }
        <Circle
            fill={categorical["5"]}
            cx={540}
            cy={110}
            r={40}
        />
    </Svg>;
};

const handlePress = () => undefined;

const Profile01 = () => {
    const {
        t
    } = useDocsI18n();

    const {
        activeLocale
    } = NCoreUIKitLocalize.useContext();

    const {
        shapeConfigs,
        avatarSizes,
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        width
    } = useWindowDimensions();

    const [
        isFollowing,
        setIsFollowing
    ] = useState(false);

    const [
        tab,
        setTab
    ] = useState("posts");

    const [
        likedPosts,
        setLikedPosts
    ] = useState<Array<string>>(["spacing"]);

    const [
        savedPosts,
        setSavedPosts
    ] = useState<Array<string>>([]);

    const [
        followedPeople,
        setFollowedPeople
    ] = useState<Array<string>>(["defne"]);

    const [
        activeTag,
        setActiveTag
    ] = useState<string | undefined>(undefined);

    const [
        search,
        setSearch
    ] = useState("");

    const isWide = width >= shapeConfigs.wideBreakpoint;

    const isCompact = width < shapeConfigs.compactBreakpoint;

    const number = new Intl.NumberFormat(activeLocale);

    const ratio = new Intl.NumberFormat(activeLocale, {
        minimumFractionDigits: 1
    });

    const toggle = (list: Array<string>, key: string) => list.includes(key) ? list.filter((item) => item !== key) : [
        ...list,
        key
    ];

    const handleFollowPress = () => setIsFollowing(!isFollowing);

    const handleTabChange = (value: string) => setTab(value);

    const handleLikePress = (key: string) => () => setLikedPosts(toggle(likedPosts, key));

    const handleSavePress = (key: string) => () => setSavedPosts(toggle(savedPosts, key));

    const handlePersonPress = (key: string) => () => setFollowedPeople(toggle(followedPeople, key));

    const handleTagPress = (key: string) => () => setActiveTag(activeTag === key ? undefined : key);

    const visiblePosts = activeTag ? POSTS.filter((post) => post.tags.some((tag) => tag === activeTag)) : POSTS;

    const renderNav = (key: string) => <Button
        title={t(`blocks.profile01.nav.${key}`)}
        spreadBehaviour="free"
        onPress={handlePress}
        variant="ghost"
        type="neutral"
        size="small"
        key={key}
    />;

    const renderStat = (key: string, value: number) => <View
        style={[
            stylesheet.baseline,
            {
                gap: spaces.spacingXs
            }
        ]}
        key={key}
    >
        <Text
            variant="titleLargeSize"
            color="high"
        >
            {number.format(value)}
        </Text>
        <Text
            variant="bodyMediumSize"
            color="mid"
        >
            {t(`blocks.profile01.stat.${key}`)}
        </Text>
    </View>;

    const renderTrigger = ({
        key,
        ...rest
    }: typeof TABS[number]) => <Tabs.Trigger
        count={"count" in rest ? rest.count : undefined}
        title={t(`blocks.profile01.tab.${key}`)}
        value={key}
        key={key}
    />;

    const renderComment = (key: string) => <View
        style={[
            stylesheet.row,
            stylesheet.start,
            {
                gap: spaces.spacingSm
            }
        ]}
        key={key}
    >
        <Avatar
            title={t(`blocks.profile01.person.${key}`)}
            size="small"
        />
        <View
            style={stylesheet.shrink}
        >
            <Text
                variant="bodyMediumSize"
                color="mid"
            >
                <Text
                    variant="labelMediumSize"
                    color="high"
                >
                    {`${t(`blocks.profile01.person.${key}`)} `}
                </Text>
                {t(`blocks.profile01.comment.${key}`)}
            </Text>
        </View>
    </View>;

    const renderTag = (key: string) => <Badge
        title={t(`blocks.profile01.tag.${key}`)}
        spreadBehaviour="free"
        variant="outline"
        type="neutral"
        key={key}
    />;

    const renderArt = (art: string) => {
        if(art === "spacing") {
            return <View
                style={[
                    stylesheet.clip,
                    {
                        borderRadius: radiuses.surface,
                        aspectRatio: ART_RATIO
                    }
                ]}
            >
                <SpacingArt/>
                <View
                    style={[
                        stylesheet.absolute,
                        stylesheet.caption
                    ]}
                >
                    <Text
                        variant={isCompact ? "titleSmallSize" : "titleLargeSize"}
                        color="contrastHigh"
                    >
                        {t("blocks.profile01.artSpacingTitle")}
                    </Text>
                    <Text
                        variant="bodySmallSize"
                        color="contrastLow"
                    >
                        2 · 4 · 8 · 16 · 24 · 32 · 48
                    </Text>
                </View>
            </View>;
        }

        if(art === "contrast") {
            return <View
                style={[
                    stylesheet.row,
                    {
                        gap: spaces.spacingMd
                    }
                ]}
            >
                {
                    CONTRASTS.map(({
                        ratio: value,
                        color
                    }) => <View
                        style={[
                            stylesheet.swatch,
                            {
                                backgroundColor: color === "inverse" ? colors.content.container.inverse : colors.chart.categorical[color],
                                borderRadius: radiuses.actions,
                                padding: spaces.spacingMd,
                                gap: spaces.spacingMd
                            }
                        ]}
                        key={color}
                    >
                        <Text
                            variant={isCompact ? "headlineMediumSize" : "displaySmallSize"}
                            color="contrastHigh"
                        >
                            Aa
                        </Text>
                        <Text
                            variant="labelSmallSize"
                            color="contrastHigh"
                        >
                            {`${ratio.format(value)} : 1`}
                        </Text>
                    </View>)
                }
            </View>;
        }

        return null;
    };

    const renderPost = (post: typeof POSTS[number]) => {
        const isLiked = likedPosts.includes(post.key);

        const isSaved = savedPosts.includes(post.key);

        const likes = post.likes - (post.isLiked ? 1 : 0) + (isLiked ? 1 : 0);

        return <Card
            variant="outline"
            key={post.key}
        >
            <Card.Content>
                {
                    post.isPinned ?
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            <Icon
                                size="small"
                                color="mid"
                                icon={Pin}
                            />
                            <Text
                                variant="bodySmallSize"
                                color="mid"
                            >
                                {t("blocks.profile01.pinned")}
                            </Text>
                        </View>
                    :
                        null
                }
                <View
                    style={[
                        stylesheet.row,
                        {
                            gap: spaces.spacingSm
                        }
                    ]}
                >
                    <Avatar
                        title={t("blocks.profile01.name")}
                        size="small"
                    />
                    <View
                        style={[
                            stylesheet.shrink,
                            {
                                flex: 1
                            }
                        ]}
                    >
                        <Text
                            variant="titleSmallSize"
                            numberOfLines={1}
                            color="high"
                        >
                            {t("blocks.profile01.name")}
                        </Text>
                        <Text
                            variant="bodySmallSize"
                            numberOfLines={1}
                            color="mid"
                        >
                            {`${t("blocks.profile01.handle")} · ${t(`blocks.profile01.post.${post.key}.time`)} · ${t(`blocks.profile01.post.${post.key}.channel`)}`}
                        </Text>
                    </View>
                    <Button
                        accessibilityLabel={t("blocks.profile01.postOptions")}
                        spreadBehaviour="free"
                        onPress={handlePress}
                        icon={EllipsisIcon}
                        variant="ghost"
                        type="neutral"
                        size="small"
                    />
                </View>
                <Text
                    variant="bodyLargeSize"
                    color="high"
                >
                    {t(`blocks.profile01.post.${post.key}.text`)}
                </Text>
                {renderArt(post.art)}
                <View
                    style={[
                        stylesheet.wrap,
                        {
                            gap: spaces.spacingSm
                        }
                    ]}
                >
                    {post.tags.map(renderTag)}
                </View>
                <Separator/>
                <View
                    style={[
                        stylesheet.spread,
                        {
                            gap: spaces.spacingXs
                        }
                    ]}
                >
                    <View
                        style={[
                            stylesheet.row,
                            stylesheet.wrap,
                            {
                                gap: spaces.spacingXs
                            }
                        ]}
                    >
                        <Button
                            accessibilityLabel={t("blocks.profile01.like", [
                                likes
                            ])}
                            variant={isLiked ? "tonal" : "ghost"}
                            onPress={handleLikePress(post.key)}
                            title={number.format(likes)}
                            spreadBehaviour="free"
                            accessibilityState={{
                                selected: isLiked
                            }}
                            icon={HeartIcon}
                            type="neutral"
                            size="small"
                        />
                        <Button
                            accessibilityLabel={t("blocks.profile01.commentsLabel", [
                                post.comments
                            ])}
                            title={number.format(post.comments)}
                            icon={MessageCircleIcon}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            variant="ghost"
                            type="neutral"
                            size="small"
                        />
                        <Button
                            accessibilityLabel={t("blocks.profile01.repostLabel", [
                                post.reposts
                            ])}
                            title={number.format(post.reposts)}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            icon={Repeat2Icon}
                            variant="ghost"
                            type="neutral"
                            size="small"
                        />
                    </View>
                    <View
                        style={stylesheet.row}
                    >
                        <Button
                            accessibilityLabel={t("blocks.profile01.saveToCollection")}
                            variant={isSaved ? "tonal" : "ghost"}
                            onPress={handleSavePress(post.key)}
                            spreadBehaviour="free"
                            icon={BookmarkIcon}
                            type="neutral"
                            size="small"
                        />
                        <Button
                            accessibilityLabel={t("blocks.profile01.share")}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            icon={Share2Icon}
                            variant="ghost"
                            type="neutral"
                            size="small"
                        />
                    </View>
                </View>
                <Card
                    variant="filled"
                >
                    <Card.Content>
                        {post.preview.map(renderComment)}
                        <View
                            style={stylesheet.start}
                        >
                            <Button
                                title={t("blocks.profile01.viewComments", [
                                    post.comments - post.preview.length
                                ])}
                                spreadBehaviour="free"
                                onPress={handlePress}
                                variant="link"
                                size="small"
                            />
                        </View>
                    </Card.Content>
                </Card>
            </Card.Content>
        </Card>;
    };

    const renderPerson = (key: string) => {
        const isFollowed = followedPeople.includes(key);

        return <Item
            size="small"
            key={key}
        >
            <Item.Media
                avatarProps={{
                    title: t(`blocks.profile01.person.${key}`)
                }}
                variant="avatar"
            />
            <Item.Content>
                <Item.Title>
                    {t(`blocks.profile01.person.${key}`)}
                </Item.Title>
                <Item.Description>
                    {t(`blocks.profile01.person.${key}Role`)}
                </Item.Description>
            </Item.Content>
            <Item.Actions>
                <Button
                    title={t(isFollowed ? "blocks.profile01.following" : "blocks.profile01.follow")}
                    variant={isFollowed ? "tonal" : "outline"}
                    onPress={handlePersonPress(key)}
                    spreadBehaviour="free"
                    type="neutral"
                    size="small"
                />
            </Item.Actions>
        </Item>;
    };

    const renderTagChip = (key: string) => <Chip
        title={t(`blocks.profile01.tag.${key}`)}
        isSelected={activeTag === key}
        onPress={handleTagPress(key)}
        spreadBehaviour="free"
        variant="outline"
        type="neutral"
        key={key}
    />;

    const renderPanel = ({
        key
    }: typeof TABS[number]) => <Tabs.Content
        value={key}
        key={key}
    >
        {
            key === "posts" ?
                <View
                    style={{
                        gap: spaces.spacingMd
                    }}
                >
                    {visiblePosts.map(renderPost)}
                </View>
            :
                <Empty
                    variant="outline"
                >
                    <Empty.Header>
                        <Empty.Title>
                            {t(`blocks.profile01.tab.${key}`)}
                        </Empty.Title>
                        <Empty.Description>
                            {t("blocks.profile01.otherDescription")}
                        </Empty.Description>
                    </Empty.Header>
                </Empty>
        }
    </Tabs.Content>;

    const followers = FOLLOWERS + (isFollowing ? 1 : 0);

    return <ScrollView
        contentContainerStyle={stylesheet.page}
    >
        <View
            style={[
                stylesheet.header,
                {
                    maxWidth: shapeConfigs.wideBreakpoint + shapeConfigs.sideListWidth,
                    paddingHorizontal: isCompact ? spaces.spacingMd : spaces.spacingLg,
                    paddingVertical: spaces.spacingSm,
                    gap: spaces.spacingSm
                }
            ]}
        >
            <View
                style={[
                    stylesheet.row,
                    {
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <BrandMark/>
                {
                    isCompact ?
                        null
                    :
                        <Badge
                            title={t("blocks.profile01.community")}
                            spreadBehaviour="free"
                            type="neutral"
                        />
                }
                {
                    isWide ?
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            {NAV.map(renderNav)}
                        </View>
                    :
                        null
                }
            </View>
            <View
                style={[
                    stylesheet.row,
                    {
                        gap: spaces.spacingSm
                    }
                ]}
            >
                {
                    isCompact ?
                        null
                    :
                        <View
                            style={{
                                width: shapeConfigs.fieldMinWidth + spaces.spacingXxl
                            }}
                        >
                            <TextInput
                                placeholder={t("blocks.profile01.searchPlaceholder")}
                                accessibilityLabel={t("blocks.profile01.search")}
                                spreadBehaviour="stretch"
                                onChangeText={setSearch}
                                icon={SearchIcon}
                                value={search}
                                size="small"
                            />
                        </View>
                }
                {
                    isWide ?
                        <Kbd
                            keys="/"
                        />
                    :
                        null
                }
                <Badge.Indicator
                    type="danger"
                >
                    <Button
                        accessibilityLabel={t("blocks.profile01.notifications")}
                        spreadBehaviour="free"
                        onPress={handlePress}
                        icon={BellIcon}
                        variant="ghost"
                        type="neutral"
                        size="small"
                    />
                </Badge.Indicator>
                <Avatar
                    title={t("blocks.profile01.me")}
                    size="xSmall"
                />
            </View>
        </View>
        <Separator
            length="100%"
        />
        <View
            style={[
                stylesheet.shell,
                {
                    maxWidth: shapeConfigs.wideBreakpoint + shapeConfigs.sideListWidth,
                    paddingHorizontal: isCompact ? spaces.spacingMd : spaces.spacingLg,
                    paddingVertical: spaces.spacingLg,
                    gap: spaces.spacingXl
                }
            ]}
        >
            <Card
                accessibilityLabel={t("blocks.profile01.profileLabel")}
                variant="outline"
            >
                <View
                    style={[
                        stylesheet.clip,
                        {
                            aspectRatio: isCompact ? shapeConfigs.bannerRatio : COVER_RATIO
                        }
                    ]}
                >
                    <Cover/>
                </View>
                <Card.Content>
                    <View
                        style={[
                            stylesheet.wrap,
                            {
                                marginTop: -avatarSizes.xLarge / 2,
                                alignItems: "flex-end",
                                gap: spaces.spacingMd
                            }
                        ]}
                    >
                        <Avatar
                            title={t("blocks.profile01.name")}
                            isShowBorder={true}
                            size="xLarge"
                        />
                        <View
                            style={[
                                stylesheet.shrink,
                                {
                                    minWidth: shapeConfigs.fieldMinWidth,
                                    gap: spaces.spacingXxs,
                                    flexGrow: 1
                                }
                            ]}
                        >
                            <View
                                style={[
                                    stylesheet.row,
                                    stylesheet.wrap,
                                    {
                                        gap: spaces.spacingSm
                                    }
                                ]}
                            >
                                <Text
                                    variant="headlineMediumSize"
                                    accessibilityRole="header"
                                    color="high"
                                >
                                    {t("blocks.profile01.name")}
                                </Text>
                                <Icon
                                    customColor={colors.content.text.info}
                                    icon={BadgeCheck}
                                    size="large"
                                />
                                <Badge
                                    title={t("blocks.profile01.moderator")}
                                    spreadBehaviour="free"
                                    type="neutral"
                                />
                            </View>
                            <Text
                                variant="bodyMediumSize"
                                color="mid"
                            >
                                {t("blocks.profile01.handle")}
                            </Text>
                        </View>
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingSm
                                }
                            ]}
                        >
                            <Button
                                accessibilityLabel={t("blocks.profile01.moreOptions")}
                                spreadBehaviour="free"
                                onPress={handlePress}
                                icon={EllipsisIcon}
                                variant="ghost"
                                type="neutral"
                            />
                            <Button
                                title={t("blocks.profile01.message")}
                                spreadBehaviour="free"
                                onPress={handlePress}
                                variant="outline"
                                icon={MailIcon}
                                type="neutral"
                            />
                            <Button
                                title={t(isFollowing ? "blocks.profile01.following" : "blocks.profile01.follow")}
                                icon={isFollowing ? UserCheckIcon : UserPlusIcon}
                                variant={isFollowing ? "tonal" : "filled"}
                                type={isFollowing ? "neutral" : "primary"}
                                onPress={handleFollowPress}
                                spreadBehaviour="free"
                            />
                        </View>
                    </View>
                    <Text
                        style={{
                            maxWidth: shapeConfigs.readingMaxWidth + shapeConfigs.fieldMinWidth
                        }}
                        variant="bodyLargeSize"
                        color="high"
                    >
                        {t("blocks.profile01.bio")}
                    </Text>
                    <View
                        style={[
                            stylesheet.wrap,
                            {
                                columnGap: spaces.spacingLg,
                                rowGap: spaces.spacingXs
                            }
                        ]}
                    >
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            <Icon
                                icon={MapPin}
                                size="small"
                                color="mid"
                            />
                            <Text
                                variant="bodyMediumSize"
                                color="mid"
                            >
                                {t("blocks.profile01.location")}
                            </Text>
                        </View>
                        <Button
                            title={t("blocks.profile01.website")}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            icon={LinkIcon}
                            variant="link"
                            size="small"
                        />
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            <Icon
                                icon={Calendar}
                                size="small"
                                color="mid"
                            />
                            <Text
                                variant="bodyMediumSize"
                                color="mid"
                            >
                                {t("blocks.profile01.joined")}
                            </Text>
                        </View>
                    </View>
                    <Separator/>
                    <View
                        style={[
                            stylesheet.spread,
                            stylesheet.wrap,
                            {
                                columnGap: spaces.spacingXl,
                                rowGap: spaces.spacingSm
                            }
                        ]}
                    >
                        <View
                            style={[
                                stylesheet.wrap,
                                {
                                    columnGap: spaces.spacingXl,
                                    rowGap: spaces.spacingXs
                                }
                            ]}
                        >
                            {renderStat("followers", followers)}
                            {renderStat("following", FOLLOWING)}
                            {renderStat("posts", POST_COUNT)}
                        </View>
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingSm
                                }
                            ]}
                        >
                            <AvatarGroup
                                avatars={[
                                    {
                                        title: t("blocks.profile01.person.can")
                                    },
                                    {
                                        title: t("blocks.profile01.person.selin")
                                    },
                                    {
                                        title: t("blocks.profile01.person.mert")
                                    }
                                ]}
                                size="xxSmall"
                            />
                            <Text
                                variant="bodyMediumSize"
                                color="mid"
                            >
                                {t("blocks.profile01.mutual", [
                                    12
                                ])}
                            </Text>
                        </View>
                    </View>
                </Card.Content>
            </Card>
            <Tabs
                onValueChange={handleTabChange}
                variant="line"
                value={tab}
            >
                <Tabs.List
                    title={t("blocks.profile01.tabsTitle")}
                >
                    {TABS.map(renderTrigger)}
                </Tabs.List>
                <View
                    style={{
                        flexDirection: isWide ? "row" : "column",
                        paddingTop: spaces.spacingMd,
                        alignItems: "flex-start",
                        gap: spaces.spacingMd
                    }}
                >
                    <View
                        style={[
                            stylesheet.shrink,
                            {
                                width: isWide ? undefined : "100%",
                                flex: isWide ? 1 : undefined
                            }
                        ]}
                    >
                        {TABS.map(renderPanel)}
                    </View>
                    <View
                        style={[
                            stylesheet.shrink,
                            {
                                width: isWide ? shapeConfigs.cardWidth : "100%",
                                gap: spaces.spacingMd,
                                flexGrow: 0
                            }
                        ]}
                    >
                        <Card
                            variant="outline"
                        >
                            <Card.Header>
                                <Card.Title>
                                    {t("blocks.profile01.suggestedTitle")}
                                </Card.Title>
                            </Card.Header>
                            <Card.Content>
                                {PEOPLE.map(renderPerson)}
                                <View
                                    style={stylesheet.start}
                                >
                                    <Button
                                        title={t("blocks.profile01.showMore")}
                                        spreadBehaviour="free"
                                        onPress={handlePress}
                                        variant="link"
                                        size="small"
                                    />
                                </View>
                            </Card.Content>
                        </Card>
                        <Card
                            variant="outline"
                        >
                            <Card.Header>
                                <Card.Title>
                                    {t("blocks.profile01.tagsTitle")}
                                </Card.Title>
                            </Card.Header>
                            <Card.Content>
                                <View
                                    style={[
                                        stylesheet.wrap,
                                        {
                                            gap: spaces.spacingSm
                                        }
                                    ]}
                                >
                                    {TAGS.map(renderTagChip)}
                                </View>
                            </Card.Content>
                        </Card>
                        <Card
                            variant="filled"
                        >
                            <Card.Header>
                                <Card.Title>
                                    {t("blocks.profile01.collectionsTitle")}
                                </Card.Title>
                                <Card.Description>
                                    {t("blocks.profile01.collectionsBody")}
                                </Card.Description>
                            </Card.Header>
                            <Card.Content>
                                <View
                                    style={stylesheet.start}
                                >
                                    <Button
                                        title={t("blocks.profile01.collectionsLink")}
                                        spreadBehaviour="free"
                                        onPress={handlePress}
                                        variant="link"
                                        size="small"
                                    />
                                </View>
                            </Card.Content>
                        </Card>
                        <Text
                            variant="bodySmallSize"
                            color="mid"
                        >
                            {t("blocks.profile01.footer")}
                        </Text>
                    </View>
                </View>
            </Tabs>
        </View>
    </ScrollView>;
};
export default Profile01;
